import React, { HTMLInputTypeAttribute } from 'react'
import { FieldHookConfig, useField, useFormikContext } from 'formik'
import { SizeVariants } from '@/shared/forms/components/constants'
import TextInput, { BaseTextInputProps } from './TextInput'

export type FormikTextInputVariant = 'text' | 'multiline'
export const FormikTextInputVariant = {
  Text: 'text' as const,
  Multiline: 'multiline' as const,
}

export type FormikTextInputProps = {
  label: string
  size: keyof typeof SizeVariants
  autocomplete: string
  variant?: FormikTextInputVariant
  disabled?: boolean
  placeholder?: string
  optional?: boolean
  type?: HTMLInputTypeAttribute
  rows?: number
  resizable?: boolean
  hideLabel?: boolean
  hasError?: boolean
  verified?: boolean
  showErrorText?: boolean
} & FieldHookConfig<string> &
  BaseTextInputProps

export default function FormikTextInput({
  label,
  size,
  autocomplete,
  disabled,
  placeholder,
  name,

  rows = 6,
  resizable = true,
  optional = false,
  type = 'text',
  variant = FormikTextInputVariant.Text,
  hideLabel = false,
  inputMode = 'text',
  hasError = false,
  onChange,
  onBlur,
  ...props
}: FormikTextInputProps) {
  const [field, meta] = useField({ name, ...props })
  const { isSubmitting } = useFormikContext()
  const isDisabled = disabled || isSubmitting
  const actualOnChange = onChange ? onChange : field.onChange
  const actualOnBlur = onBlur ? onBlur : field.onBlur

  return (
    <TextInput
      type={type}
      size={size}
      id={props.id}
      label={label}
      name={field.name}
      value={field.value ?? ''}
      onChange={actualOnChange}
      onBlur={actualOnBlur}
      disabled={isDisabled}
      error={meta.error}
      touched={meta.touched}
      variant={variant}
      resizable={resizable}
      placeholder={placeholder}
      hideLabel={hideLabel}
      optional={optional}
      inputMode={inputMode}
      autocomplete={autocomplete}
      hasError={hasError}
      rows={rows}
      {...props}
    />
  )
}
